import {
	db,
	IModel,
	IVIPProductionBase,
	VIPProductionBase,
} from "@/loader";

/**
 * Production Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPProduction extends IVIPProductionBase {
}

/**
 * Production Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPProduction extends VIPProductionBase implements IVIPProduction, IModel<IVIPProduction> {
	constructor (data: IVIPProduction = {}) {
		super(data);
	}

	public load(data: IVIPProduction) {
		super.load(data);
	}

	public update(data: IVIPProduction) {
		super.update(data);
	}

	public setSlug() {
		let index = 0;
		do {
			index++;
			this.slug = this.name.kebabCase() + (index > 1 ? index : "");
		} while (db.productions.list.find(p => p.id !== this.id && p.slug === this.slug));
	}
}
